import { Link } from 'react-router-dom';
import type { SiteSettings } from '@sazerac/design-tokens';
import logoWhite from '../assets/logo-white.png';

const EXPLORE = [
  { to: '/', label: 'Home' },
  { to: '/our-story', label: 'Our Story' },
  { to: '/menu/drinks', label: 'Drinks' },
  { to: '/menu/food', label: 'Food' },
  { to: '/experiences', label: 'Experiences' },
  { to: '/events', label: 'Events' },
];

const SERVICES = [
  { to: '/reservations', label: 'Reservations' },
  { to: '/concierge', label: 'Concierge' },
  { to: '/laundry', label: 'Laundry Service' },
  { to: '/manage-reservation', label: 'Manage Reservation' },
];

const LEGAL = [
  { to: '/policies/privacy-policy', label: 'Privacy Policy' },
  { to: '/policies/cookie-policy', label: 'Cookie Policy' },
  { to: '/policies/reservation-terms', label: 'Reservation Terms' },
  { to: '/policies/cancellation-policy', label: 'Cancellation Policy' },
  { to: '/policies/concierge-terms', label: 'Concierge Terms' },
  { to: '/policies/laundry-terms', label: 'Laundry Service Terms' },
];

export function Footer({ site }: { site?: SiteSettings }) {
  const year = new Date().getFullYear();

  return (
    <footer className="sz-footer sz-no-print">
      <div className="sz-footer__grid">
        <div>
          <img src={logoWhite} alt="SAZERAC" className="sz-footer__logo" />
          <p className="sz-footer__blurb">
            A refined café and bar experience shaped by exceptional drinks, warm hospitality and
            unforgettable moments.
          </p>
        </div>

        <div>
          <p className="sz-footer__heading">Explore</p>
          <div className="sz-footer__links">
            {EXPLORE.map((item) => (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="sz-footer__heading">Services</p>
          <div className="sz-footer__links">
            {SERVICES.map((item) => (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="sz-footer__heading">Legal</p>
          <div className="sz-footer__links">
            {LEGAL.map((item) => (
              <Link key={item.to} to={item.to}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="sz-footer__heading">Follow</p>
          <div className="sz-footer__links">
            {site?.instagramUrl && (
              <a href={site.instagramUrl} target="_blank" rel="noreferrer noopener">
                Instagram
              </a>
            )}
            {site?.facebookUrl && (
              <a href={site.facebookUrl} target="_blank" rel="noreferrer noopener">
                Facebook
              </a>
            )}
            {site?.supportEmail && <a href={`mailto:${site.supportEmail}`}>{site.supportEmail}</a>}
          </div>
        </div>
      </div>

      {/* While the site runs on seeded demo content, say so plainly rather than let
          sample prices, hours and quotes read as verified facts. */}
      {site?.showDemoContentNotice && (
        <p className="sz-footer__legal sz-footer__legal--notice">
          Demo content: prices, opening hours, address and imagery on this site are sample data from
          the design prototype and have not been confirmed by the venue.
        </p>
      )}

      <p className="sz-footer__legal">
        Typefaces: Spectral (substitute for FS Siena-SemiBold) · Manrope (substitute for Gotham) —
        replace with the licensed brand fonts before launch.
      </p>
      <p className="sz-footer__copyright">© {year} SAZERAC. All rights reserved.</p>
    </footer>
  );
}
